import { render, staticRenderFns } from "./ResourceListWrapper.vue?vue&type=template&id=93150596&scoped=true&"
import script from "./ResourceListWrapper.vue?vue&type=script&lang=js&"
export * from "./ResourceListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ResourceListWrapper.vue?vue&type=style&index=0&id=93150596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93150596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
